module.exports = __webpack_public_path__ + "static/date_sp_dark-03c633581c7d2b49158c7b130c2e2063.svg";